<template>
  <div class="accordion-wrapper col-sm-12">
    <div style="margin-top: -15px;" class="text-right">
      <a
        class="link_action hover-btn toggle-description-btn"
        href="#"
        @click.prevent="toggleDescription"
      >
        {{ showMore ? 'more' : 'less' }}
      </a>
    </div>

    <div
      class="accordion-product-description"
      v-show="!showMore"
      v-html="cleanedDescription"
      v-accordion
    ></div>
  </div>
</template>

<script>
export default {
  name: 'AccordionDescription',
  props: {
    descriptionHtml: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      showMore: true
    };
  },
  methods: {
    toggleDescription() {
      this.showMore = !this.showMore;
    }
  },
  directives: {
    accordion: {
      inserted(el) {
        el.addEventListener('click', (event) => {
          if (event.target.matches('dt a')) {
            event.preventDefault();
            const dt = event.target.closest('dt');
            const dd = dt?.nextElementSibling;
            const icon = dt?.querySelector('small.right');

            if (dd && dd.tagName.toLowerCase() === 'dd') {
              const isVisible = dd.style.display === 'block';
              dd.style.display = isVisible ? 'none' : 'block';

              if (icon) {
                icon.classList.toggle('rotated', !isVisible);
              }
            }
          }
        });
      }
    }
  },
  computed: {
    cleanedDescription() {
      return this.descriptionHtml.replace(/\u00A0/g, '');
    }
  }
};
</script>

<style lang="scss">
  .accordion-wrapper {
    .accordion-product-description {
      padding-top: 20px;
      width: 100%;
      
      dl {
        margin-bottom: 0;
      }
    
    }

    .accordion dt {
      border-bottom: 0.5px;
      position: relative;
    }

    .accordion dt a,
    .accordion dt button {
      background: none;
      border: 0;
      border-bottom: 0.5px solid #B3AFAF !important;
      color: #2b2a2d;
      cursor: pointer;
      display: block;
      font-size: 1.2rem;
      padding: 20px 20px 20px 40px;
      text-align: left;
      width: 100%;
      transition: background-color 0.2s linear;
    }

    .accordion dt a:hover {
      background-color: rgba(43, 42, 45, 0.03);
    }

    .accordion dt small,
    .accordion dt .icon {
      position: absolute;
      left: 10px;
      top: 50%;
      transform: translateY(-60%);
      transition: transform 0.2s linear;
    }

    .accordion dt .accordion-style--plus_and_minus .icon {
      display: none;
    }

    .accordion dt .accordion-style--plus_and_minus .icon.icon--active {
      display: block;
    }

    small.right.rotated {
      transform: translateY(-60%) rotate(270deg);
    }

    .accordion dd {
      display: none;
      padding: 20px 20px 20px 40px;
      margin-left: 0;
    }
    .accordion dd.active {
      display: block;
    }
  }
</style>
